import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ color }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: rem(50.5),
    gap: rem(8),
  },
  header: {
    display: 'flex',
    gap: rem(12),
    overflow: 'hidden',
  },
  headerItem: {
    display: 'flex',
    alignItems: 'center',
    gap: rem(4),
    flex: 1,
    overflow: 'hidden',
    maxWidth: 'fit-content',
  },
  infos: {
    display: 'flex',
    alignItems: 'center',
    gap: rem(4),
  },
  review: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: rem(4),
  },
  ellipse: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
  tagNewTeacher: {
    backgroundColor: color.background.success.neutral,
    padding: `${rem(2)} ${rem(12)}`,

    '& span': {
      color: color.foreground.success,
    },
  },
}));
